import { tokenTypes, } from '../../types.js';
import { ARToTokenAmount, ArweaveToken } from './arweave.js';
import { BaseEthToken } from './baseEth.js';
import { ETHToTokenAmount, EthereumToken } from './ethereum.js';
import { KYVEToTokenAmount, KyveToken } from './kyve.js';
import { POLToTokenAmount, PolygonToken } from './polygon.js';
import { SOLToTokenAmount, SolanaToken } from './solana.js';
export const defaultTokenMap = {
    arweave: (config) => new ArweaveToken(config),
    solana: (config) => new SolanaToken(config),
    ethereum: (config) => new EthereumToken(config),
    'base-eth': (config) => new BaseEthToken(config),
    kyve: (config) => new KyveToken(config),
    matic: (config) => new PolygonToken(config),
    pol: (config) => new PolygonToken(config),
};
const ethExponent = 18;
export const exponentMap = {
    arweave: 12,
    solana: 9,
    ethereum: ethExponent,
    'base-eth': ethExponent,
    kyve: 6,
    matic: ethExponent,
    pol: ethExponent,
};
export const tokenToBaseMap = {
    arweave: (a) => ARToTokenAmount(a),
    solana: (a) => SOLToTokenAmount(a),
    ethereum: (a) => ETHToTokenAmount(a),
    'base-eth': (a) => ETHToTokenAmount(a),
    kyve: (a) => KYVEToTokenAmount(a),
    matic: (a) => POLToTokenAmount(a),
    pol: (a) => POLToTokenAmount(a),
};
export function isTokenType(token) {
    return tokenTypes.includes(token);
}
export * from './arweave.js';
export * from './solana.js';
export * from './ethereum.js';
export * from './baseEth.js';
export * from './polygon.js';
export * from './kyve.js';
